import React from 'react';
import svgimage from '../images/SideImage.svg';
import './Project.css';
import ReactSVG from 'react-svg';

const ProjectImage = () => (
  <a className='dancehall' href='https://dancehall-lite.firebaseapp.com/' target='_blank' rel='noopener noreferrer'>
    <ReactSVG path={svgimage} callback={svg => console.log(svg)}  style={{width: 375, height: 667 }} />
  </a>
)

export default ProjectImage;



// WEBPACK FOOTER //
// ./src/container/Project/ProjectImage.js